import { UseMutationOptions } from "@tanstack/react-query";
import { API_REGISTER_URL } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";

interface IRequest {
    email: string;
    password: string;
    agbs: boolean;
    newsletter: boolean;
    sendPromotion: boolean;
    promotionId?: string;
    welcomePageNodeId: number | null;
    originPagePath?: string;
    platform: string;
}

interface IError {
    [fieldName: string]: string;
}

interface IRegisterResponse {
    returnUrl: string;
}

export const useRegisterMutation = (options: UseMutationOptions<IRegisterResponse, IError, IRequest>) => {
    const { mutate: registerUser } = useMutation<IRegisterResponse, IError, IRequest>(API_REGISTER_URL, options);
    return registerUser;
};
